<template>
    <v-autocomplete
        v-model="vacation"
        :items="vacations"
        :loading="loading"
        hide-no-data
        item-text="text"
        item-value="id"
        label="Vacation"
        single-line
        hide-details
        dense
        return-object />
</template>

<script>
export default {
    name: 'pad-vacation-selector',
    data: () => ({
        vacations: [],
        loading: false,
        search: ''
    }),
    computed: {
        vacation: {
            get() {
                return this.$store.getters['sale/vacation']
            },
            set(v) {
                if (!v) {
                    return
                }
                this.$store.commit('sale/setVacation', { vacation: v })
            }
        },
        saleId() {
            return this.$store.getters['sale/sale'].id
        }
    },
    watch: {
        saleId: 'load'
    },
    mounted() {
        if (!this.vacations.length && this.vacation && this.vacation.id) {
            this.vacations.push({ ...this.vacation })
        }
        this.load()
    },
    methods: {
        load() {
            this.vacation = null
            if (!this.saleId) {
                return
            }
            this.loading = true
            this.$api.get(`/sales/${this.saleId}/vacations`)
                .then((res) => {
                    this.vacations = res.data
                    this.$store.commit('sale/setVacations', { vacations: res.data })
                })
                .finally(() => this.loading = false)
        }
    }
}
</script>
